import { render, staticRenderFns } from "./work-order-desk-add.vue?vue&type=template&id=4dddad71&scoped=true"
import script from "./work-order-desk-add.vue?vue&type=script&lang=js"
export * from "./work-order-desk-add.vue?vue&type=script&lang=js"
import style0 from "./work-order-desk-add.vue?vue&type=style&index=0&id=4dddad71&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dddad71",
  null
  
)

export default component.exports